<div class="popup-dialog">
    <div class="trezo-card w-100 border-radius d-block bg-white border-0 shadow-none">
        <div class="trezo-card-header d-flex align-items-center justify-content-between">
            <div class="trezo-card-title">
                <h5 class="mb-0">
                    {{ titleText }}
                </h5>
            </div>
            <div class="trezo-card-subtitle">
                <button (click)="toggleClass()" class="p-0 border-0 lh-1 bg-transparent transition">
                    <i class="ri-close-fill"></i>
                </button>
            </div>
        </div>
        <form [formGroup]="frmGroup" (ngSubmit)="onSave()" style="max-height: 75vh; overflow-y: auto;">
            <div class="trezo-card-content">
                <!-- User Information -->
                <h5 class="mb-3">User Information</h5>
                <div class="row">
                    <div class="col-sm-4">
                        <!-- firstName -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                First Name <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" placeholder="First Name" formControlName="firstNameControl" maxlength="200" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['firstNameControl']!.hasError('required')
                                ">
                                B2CClient firstName is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['firstNameControl']!.hasError(
                                        'onlyWhitespace'
                                    )
                                ">
                                B2CClient firstName can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <!-- lastName -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Last Name <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" placeholder="Last Name" formControlName="lastNameControl" maxlength="200" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['lastNameControl']!.hasError('required')
                                ">
                                B2CClient lastName is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['lastNameControl']!.hasError(
                                        'onlyWhitespace'
                                    )
                                ">
                                B2CClient lastName can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <!-- email -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Email <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" placeholder="Email" formControlName="emailControl" maxlength="200" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['emailControl']!.hasError('required')
                                ">
                                B2CClient email is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['emailControl']!.hasError(
                                        'onlyWhitespace'
                                    )
                                ">
                                B2CClient email can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <!-- phone -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Phone <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" placeholder="Phone" formControlName="phoneControl" maxlength="200" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['phoneControl']!.hasError('required')
                                ">
                                B2CClient phone is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['phoneControl']!.hasError(
                                        'onlyWhitespace'
                                    )
                                ">
                                B2CClient phone can not be only whitespace.
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Client Information -->
                <h5 class="mt-4 mb-3">Client Information</h5>
                <div class="row">
                    <div class="col-sm-4">
                        <!-- clientName -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Client Name <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" placeholder="Client Name" formControlName="clientNameControl" maxlength="200" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['clientNameControl']!.hasError('required')
                                ">
                                B2CClient clientName is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['clientNameControl']!.hasError(
                                        'onlyWhitespace'
                                    )
                                ">
                                B2CClient clientName can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <!-- description -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Description <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" placeholder="Description" formControlName="descriptionControl" maxlength="200" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['descriptionControl']!.hasError(
                                        'required'
                                    )
                                ">
                                B2CClient description is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['descriptionControl']!.hasError(
                                        'onlyWhitespace'
                                    )
                                ">
                                B2CClient description can not be only
                                whitespace.
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Tenant Information -->
                <h5 class="mt-4 mb-3">Tenant Information</h5>
                <div class="row">
                    <div class="col-sm-4">
                        <!-- tenantName -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Tenant Name <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" placeholder="Tenant Name" formControlName="tenantNameControl" maxlength="200" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['tenantNameControl']!.hasError('required')
                                ">
                                B2CClient tenantName is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['tenantNameControl']!.hasError(
                                        'onlyWhitespace'
                                    )
                                ">
                                B2CClient tenantName can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <!-- isMainTenant -->
                    <!-- <div class="col-sm-4">
                        <div class="form-group">
                            <label
                                class="main-label d-block fw-medium text-black"
                            >
                                Is Main Tenant
                                <span class="text-danger">*</span>
                            </label>
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="isMainTenant"
                                formControlName="isMainTenantControl"
                            />
                            
                            <div
                                class="form-text text-danger"
                                *ngIf="
                                    isSubmitted &&
                                    f['isMainTenantControl']!.hasError(
                                        'required'
                                    )
                                "
                            >
                                Please confirm if this is the main tenant.
                            </div>
                        </div>
                    </div> -->
                    <div class="col-sm-4">
                        <!-- logoUrl -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Logo
                            </label>
                            <div class="d-flex align-items-center gap-3">
                                <img
                                    *ngIf="b2ccient.logoBase64 || b2ccient.logoUrl"
                                    [src]="getLogoPreviewUrl()"
                                    alt="Logo Preview"
                                    style="width: 60px; height: 60px; object-fit: contain; border: 1px solid #dee2e6; border-radius: 4px; padding: 2px;"
                                />
                                <div>
                                    <input
                                        #logoFileInput
                                        type="file"
                                        accept="image/*"
                                        class="d-none"
                                        (change)="onLogoFileChange($event)"
                                    />
                                    <button
                                        type="button"
                                        class="btn btn-outline-secondary btn-sm"
                                        (click)="logoFileInput.click()"
                                    >
                                        {{ (b2ccient.logoBase64 || b2ccient.logoUrl) ? 'Change Image' : 'Select Image' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Address Information -->
                <h5 class="mt-4 mb-3">Address Information</h5>
                <div class="row">
                    <div class="col-sm-4">
                        <!-- addressLine1 -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Address Line 1
                                <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" placeholder="Address Line 1" formControlName="addressLine1Control" maxlength="200" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['addressLine1Control']!.hasError(
                                        'required'
                                    )
                                ">
                                B2CClient addressLine1 is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['addressLine1Control']!.hasError(
                                        'onlyWhitespace'
                                    )
                                ">
                                B2CClient addressLine1 can not be only
                                whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <!-- addressLine2 -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Address Line 2
                                <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" placeholder="Address Line 2" formControlName="addressLine2Control" maxlength="200" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['addressLine2Control']!.hasError(
                                        'required'
                                    )
                                ">
                                B2CClient addressLine2 is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['addressLine2Control']!.hasError(
                                        'onlyWhitespace'
                                    )
                                ">
                                B2CClient addressLine2 can not be only
                                whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <!-- landmark -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Landmark <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" placeholder="Landmark" formControlName="landmarkControl" maxlength="200" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['landmarkControl']!.hasError('required')
                                ">
                                B2CClient landmark is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['landmarkControl']!.hasError(
                                        'onlyWhitespace'
                                    )
                                ">
                                B2CClient landmark can not be only whitespace.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-4">
                        <!-- pinCode -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Pin Code <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" placeholder="Pin Code" formControlName="pinCodeControl" maxlength="200" />
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['pinCodeControl']!.hasError('required')
                                ">
                                B2CClient pinCode is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['pinCodeControl']!.hasError(
                                        'onlyWhitespace'
                                    )
                                ">
                                B2CClient pinCode can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <!-- Country -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Country <span class="text-danger">*</span>
                            </label>
                            <select class="form-select" formControlName="countryNameControl" [compareWith]="countryNameComparer" (change)="
                                    onCountryChange(
                                        f['countryNameControl'].value
                                    )
                                " [ngClass]="{
                                    'is-invalid':
                                        isSubmitted &&
                                        f['countryNameControl']!.hasError(
                                            'required'
                                        )
                                }">
                                <option [ngValue]="null" disabled>
                                    Please Select
                                </option>
                                <option *ngFor="let c of country$ | async" [ngValue]="c">
                                    {{ c.name }}
                                </option>
                            </select>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['countryNameControl']!.hasError(
                                        'required'
                                    )
                                ">
                                Country Name is required.
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <!-- State -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                State <span class="text-danger">*</span>
                            </label>
                            <select class="form-select" formControlName="stateNameControl" [compareWith]="stateNameComparer" (change)="
                                    onStateChange(f['stateNameControl'].value)
                                " [ngClass]="{
                                    'is-invalid':
                                        isSubmitted &&
                                        f['stateNameControl']!.hasError(
                                            'required'
                                        )
                                }">
                                <option [ngValue]="null" disabled>
                                    Please Select
                                </option>
                                <option *ngFor="let c of state" [ngValue]="c">
                                    {{ c.name }}
                                </option>
                            </select>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['stateNameControl']!.hasError('required')
                                ">
                                State Name is required.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-4">
                        <!-- City -->
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                City <span class="text-danger">*</span>
                            </label>
                            <select class="form-select" formControlName="cityNameControl" [compareWith]="cityNameComparer" [ngClass]="{
                                    'is-invalid':
                                        isSubmitted &&
                                        f['cityNameControl']!.hasError(
                                            'required'
                                        )
                                }">
                                <option [ngValue]="null" disabled>
                                    Please Select
                                </option>
                                <option *ngFor="let c of city" [ngValue]="c">
                                    {{ c.name }}
                                </option>
                            </select>
                            <div class="form-text text-danger" *ngIf="
                                    isSubmitted &&
                                    f['cityNameControl']!.hasError('required')
                                ">
                                City Name is required.
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Active / Inactive (edit only) -->
                <div class="row mt-3" *ngIf="currentUserId !== 0">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">Status</label>
                            <div class="form-check form-switch mt-1">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="b2cIsActiveToggle"
                                    formControlName="isActiveControl"
                                />
                                <label class="form-check-label" for="b2cIsActiveToggle">
                                    {{ f['isActiveControl'].value ? 'Active' : 'Inactive' }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Buttons -->
                <div class="btn-box mt-4">
                    <button type="button" (click)="toggleClass()" class="warn d-inline-block fw-medium border-0 border-radius transition">
                        Cancel
                    </button>
                    <button class="primary d-inline-block fw-medium border-0 border-radius transition" [disabled]="!formIsValid() || !dataHasChanged()">
                        <span class="position-relative d-inline-block">
                            <i class="material-symbols-outlined">{{ currentUserId === 0 ? 'add' : 'edit' }}</i>
                            {{ titleButton }}
                        </span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>